import { useState, useEffect, useCallback } from 'react';

const KEY = 'abriola_favs';
const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
const write = (a) => localStorage.setItem(KEY, JSON.stringify(a));

export function useFavorites() {
  const [favs, setFavs] = useState(read);
  const toggle = useCallback((id) => {
    setFavs(cur => {
      const next = cur.includes(id) ? cur.filter(x => x !== id) : [...cur, id];
      write(next);
      return next;
    });
  }, []);
  return [favs, toggle];
}
